/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { TransportMiddlewareProps, downloadBlob, isErrorThatNeedToBeShown } from '../../../../core';
import { getStrBetween } from '../../../../helpers/string-helpers';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const handleHttpDownloadResponseMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { options } = req;
    const { response } = res;
    const { noAutoDownload } = options;

    if (!response.ok) {
        next(res);
    } else {
        response.blob()
            .then((blob: Blob) => {
                const disposition: string = response.headers.get('Content-Disposition') || '';
                const possibleFilename = getStrBetween(disposition, 'filename=', ';');
                const filenameWithEncoding = decodeURIComponent(
                    possibleFilename === ''
                        ? getStrBetween(disposition, 'filename*=', ';')
                        : possibleFilename
                );
                const filename = filenameWithEncoding.replace(/^[a-z0-9-_]{1,15}''/i, '');

                if (noAutoDownload) {
                    res[TransportMiddlewareProps.ResponseProp] = { blob, filename } as any as R;
                } else {
                    downloadBlob(blob, filename);
                    res[TransportMiddlewareProps.ResponseProp] = {} as any as R;
                }

                next();
            })
            .catch((err: Error) => {
                isErrorThatNeedToBeShown(err) && console.error(err);
                res[TransportMiddlewareProps.ErrorResponse] = err;
                next(res);
            });
    }
};
